import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initOtel } from './opentelemetry/init-otel';
import { initSessionId } from './app/core/session/session-id';
import { environment } from './environments/environment';

// Initialize session id and OpenTelemetry as early as possible
initSessionId();
initOtel({
  serviceName: 'knab-payment-requests-web',
  environment: environment.name ?? 'development',
  otlpTracesUrl: environment.otlpTracesUrl,
  otlpMetricsUrl: environment.otlpMetricsUrl,
  otlpLogsUrl: environment.otlpLogsUrl
});

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) => console.error(err));
